<template>
    <div id="about">
        <div class="div-block-4"></div>
        <div data-collapse="medium" data-animation="default" data-duration="400" class="header-navigation fixed w-nav">
            <NetworkStatus/>
            <HeaderMenu/>
        </div>

        <div>
            <div class="section section-color center">
                <div class="w-container" style="padding:50px 0 0 0">
                    <h1 class="key-number">LocalScale for Accounting Firms</h1>
                </div>
            </div>

            <div class="center" style="margin:20px 30px">
                <div class="industry-container">
                    <div class="industry-text">
                        <p style="font-size: 18px;font-weight:bold">Elevate your accounting firm's online presence and attract new clients with LocalScale, your partner in targeted advertising</p>
                        <p>As an accounting firm, your reputation and expertise are crucial to attracting clients.</p>
                        <p>With LocalScale, you can enhance your visibility in your local community and connect with individuals and businesses in need of accounting services.</p>
                        <p>Whether you specialize in tax preparation, bookkeeping, or financial consulting, our precision-targeted ad network allows you to reach potential clients in your target markets with ease.</p>
                        <p>By leveraging LocalScale, you can ensure that your firm stands out from the competition and remains top-of-mind when individuals and businesses are seeking accounting assistance.</p>
                        <p>Let us help you grow your client base and solidify your position as a trusted accounting partner in your community.</p>
                        <div class="button-group" style="margin-top: 20px;margin-bottom: 10px;">
                            <div class="navigation-action"><a href="signup.html" class="ds-button button-small w-button">{{$t('get_started')}}</a></div>
                        </div>
                    </div>
                    <div class="industry-image">
                        <img src="images/industry-accounting.png" alt="Accounting">
                    </div>
                </div>
            </div>

            <div style="width: 100%;background-color:#e6faf6;">
                <div class="testimonial">
                    <div class="testimonial-stars">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                    </div>
                    <h3 class="testimonial-quote">“LocalScale has been instrumental in helping our accounting firm expand its reach and attract new clients. Their targeted advertising solutions have allowed us to effectively connect with individuals and businesses seeking accounting expertise, resulting in a noticeable increase in client inquiries. Thanks to LocalScale, we've been able to grow our firm and continue providing high-quality accounting services to our clients with confidence.”</h3>
                    <p class="testimonial-customer">– Julie Rodriguez, Partner at Rodriguez Financial Services</p>
                </div>
            </div>

            <Plans :what_are_you_waiting_for="true"/>
        </div>

        <Footer/>

    </div>
</template>

<script>
        import HeaderMenu from "../components/HeaderMenu";
import NetworkStatus from "../components/NetworkStatus.vue";
    import Footer from "../components/Footer";
    import Plans from "../components/Plans";

    export default {
        components: {
            HeaderMenu, NetworkStatus, Footer, Plans
        }
    }
</script>

<style>
    body {
        font-family: Inter, sans-serif;
        background-color: #fff;
    }
    p {
        color: black;
        margin: 10px;
        font-size: 16px;
    }
    h2 {
        text-align: center;
    }
    a {
        text-decoration: none;
        color: #1f1f1f
    }
</style>
